import styled from "styled-components";
import { Flex } from "antd";
import { CaretUpOutlined } from "@ant-design/icons";
import { BAR_HEIGHT, TEAL } from "../../EmployeeSkillsBridgerV2.constants";

// ─── Wrapper ──────────────────────────────────────────────────────────────────

export const BarWrapperStyled = styled.div`
  position: relative;
`;

// ─── Value label ──────────────────────────────────────────────────────────────

export const BarLabelStyled = styled.span`
  position: absolute;
  top: 0;
  height: ${BAR_HEIGHT}px;
  line-height: ${BAR_HEIGHT}px;
  font-size: 11px;
  font-weight: 700;
  pointer-events: none;
  user-select: none;
  padding-right: 5px;
  transform: translateX(-100%);
  left: ${(p) => p.$left};
  color: ${(p) => p.$color};
  z-index: ${(p) => p.$zIndex};
`;

// ─── Required Proficiency Arrow Indicator ─────────────────────────────────────

export const PointerRowStyled = styled.div`
  position: relative;
  height: 28px;
  width: 100%;
  margin-top: -8px;
`;

export const RequiredIndicatorStyled = styled(Flex)`
  position: absolute;
  left: ${(p) => p.$pct}%;
  transform: translateX(-50%);
  top: 0;
`;

export const RequiredCaretIconStyled = styled(CaretUpOutlined)`
  color: ${TEAL};
  font-size: 14px;
`;

export const RequiredValueStyled = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${TEAL};
  line-height: 1;
`;

// ─── Antd Progress style config (passed to antd `styles` prop) ────────────────

export const BAR_TRAIL_STYLE = { stroke: "#e9ecef" };
